/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Description/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import InlineNoteEditor from 'DesignSystem/InlineNoteEditor/index'
import React from 'react'
import TysiaTextareaLabel from 'DesignSystem/TysiaTextarea/TysiaTextareaLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Description({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/TaskInsertNew/Description"
  
}) {
let eventActionDataDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.description',
})
let constantData = 'task-description-'
let eventActionIdValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'id',
})
let aggregateData = fromAggregate.joinNoSpace(constantData, eventActionIdValueData)
let tokensValueData = fromData.useDataFormat({ viewPath,
context: 'tokens',
format: fromHelpers.getToolbar,
})
let tokensValueData1 = fromData.useDataValue({ viewPath,
context: 'tokens',
})
let onChange = fromHelpers.useDataOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaTextareaLabel
  viewPath={`${viewPath}/TysiaTextareaLabel`}
 text="Description"
/>
<div
  data-testid="Description.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<InlineNoteEditor
  viewPath={`${viewPath}/InlineNoteEditor`}
 data="event_action.data.description"
 value={eventActionDataDescriptionValueData}
 onChange={onChange}
 data="'task-description-'"
 data="event_action.id"
 aggregate="/Data/aggregate.js joinNoSpace"
 containerId={aggregateData}
 marginTop={0}
 marginBottom={0}
 width="100%"
 parentHeight={200}
 toolbarPersist={false}
 data="tokens"
 format="helpers.js getToolbar"
 toolbar={tokensValueData}
 maxLength={10}
 data="tokens"
 tokens={tokensValueData1}
/>
</div>
{children}
</React.Fragment>)
}